import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea } from "rbx";

import { BooleanInput, SystemCodeSelect } from "../inputs";

function GLMainAccountForm({ inputs, onChange }) {
  return (
    <React.Fragment>
      <Field kind="group">
        <Control expanded className="is-required">
          <Label>Account Number</Label>
          <Input
            required
            autocomplete="new"
            name="MainAccountId"
            type="text"
            value={inputs?.MainAccountId}
            onChange={onChange}
          />
        </Control>
        <Control expanded>
          <SystemCodeSelect
            required
            icon="globe"
            label="Account Type"
            lookup={{ Category: "General Ledger", Code: "AcctType" }}
            name="TypeRecIdRef"
            value={inputs.TypeRecIdRef}
            onChange={onChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            label="Active"
            name="Active"
            value={inputs.Active}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control>
          <Label>Description</Label>
          <Textarea
            required
            name="Description"
            rows="3"
            type="text"
            value={inputs.Description}
            onChange={onChange}
          />
        </Control>
      </Field>
    </React.Fragment>
  );
}

GLMainAccountForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
GLMainAccountForm.defaultProps = {
  inputs: {}
};
export default GLMainAccountForm;
